import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Thumbs, Pagination } from 'swiper/core'

Swiper.use([Navigation, Thumbs, Pagination])

export default class extends Controller {
  static targets = ['large']

  connect () {
    const imagesCount = this.largeTarget.dataset.imagesCount

    this.slider = new Swiper(this.largeTarget, {
      loop: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionTotal: function (number) {
          return imagesCount
        },
      },
      navigation: {
        nextEl: '#swiperButtonNext',
        prevEl: '#swiperButtonPrev',
      },
    })
  }
}
